import PropTypes from "prop-types";
import { Card, Typography } from "@mui/material";
import { formatNumber } from "src/utils/formatNumberHelper";

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

export default function AppWidgetSummary({
  title,
  total,
  icon,
  color = "primary",
  sx,
  format = "number",
  ...other
}) {
  return (
    <Card
      sx={{
        py: 2,
        px: 2,
        boxShadow: 0,
        textAlign: "center",
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5">{formatNumber(total, format)}</Typography>

      <Typography variant="subtitle4" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
    </Card>
  );
}
